import React from "react";
import Search from "../form/Search";
import FilterPopover from "../popup/FilterPopover";

const DefaultTab = ({
  tabs,
  activeTab,
  onTabChange,
  searchValue,
  onSearchChange,
  onFilterApply,
}) => {
  const filterMap = {
    All: "all",
    Active: "active",
    Inactive: "inactive",
    BillDue: "bill_due",
  };
  return (
    <section className="max-w-7xl mx-auto px-4">
      {/* Tabs Header */}
      <div className="flex justify-evenly md:justify-start">
        {tabs.map((tab) => (
          <button
            key={tab.id}
            onClick={() => onTabChange(tab.id)}
            className={`px-4 py-2 text-sm font-medium transition
              ${
                activeTab === tab.id
                  ? "border-b-2 border-orange-500 text-orange-600"
                  : "text-gray-500 hover:text-gray-700"
              }
            `}
          >
            {tab.label}
          </button>
        ))}
      </div>

      {/* Search + Filter */}
      <div className="w-full mt-4 flex gap-2 justify-center md:justify-start px-4 md:px-0">
        <Search
          extraClasses="w-full"
          searchValue={searchValue}
          onSearch={onSearchChange}
        />
        <FilterPopover
          activeTab={activeTab}
          onApply={(value) => {
            onFilterApply(value);
          }}
        />
      </div>

      {/* Tab Content */}
      <div
        className="mt-4 p-0 md:p-4 md:border md:rounded-lg  md:bg-white 
             max-w-7xl mx-auto 
             flex justify-center"
      >
        {tabs.map(
          (tab) =>
            activeTab === tab.id && (
              <div key={tab.id} className="w-full">
                {tab.content}
              </div>
            ),
        )}
      </div>
    </section>
  );
};

export default DefaultTab;
